var map = {
	"./project_case_img1.png": 9895,
	"./project_case_img10.png": 5559,
	"./project_case_img11.png": 9774,
	"./project_case_img12.png": 6501,
	"./project_case_img13.png": 4876,
	"./project_case_img14.png": 4275,
	"./project_case_img15.png": 8090,
	"./project_case_img2.png": 1420,
	"./project_case_img3.png": 4309,
	"./project_case_img4.png": 10,
	"./project_case_img5.png": 1587,
	"./project_case_img6.png": 8376,
	"./project_case_img7.png": 4673,
	"./project_case_img8.png": 3190,
	"./project_case_img9.png": 4927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;